import React from 'react';
const links = ['Kontakt', 'Regulamin', 'Polityka prywatności', 'Zwroty'];
export function SiteFooter() {
  return <footer className="w-full bg-white" data-id="element-147" data-mp="3r9aqrjnhrs1b">
      <div className="mx-auto max-w-content px-6 py-12 text-center" data-id="element-148" data-mp="3ralszf1agrqb">
        <p className="font-display text-[13px] font-bold uppercase tracking-[0.14em] text-ink" data-id="element-149" data-mp="3mfydu6s6d9oe">
          Plastyka Gotowa™
        </p>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[10px] text-muted" data-id="element-150" data-mp="3hglpfhlnnujp">
          {links.map(link => <li key={link} data-id="element-151" data-mp="38gq9z0l2hddv">
              <a href="#oferta" className="transition-colors duration-150 ease-out hover:text-coral" data-id="element-152" data-mp="38ggkrf7uja98">
                {link}
              </a>
            </li>)}
        </ul>

        <p className="mt-5 text-[9px] text-muted/70" data-id="element-153" data-mp="11rbt0ak3c6fu">
          © 2026 Plastyka Gotowa. Wszystkie prawa zastrzeżone.
        </p>
      </div>
    </footer>;
}